var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('Transition',{attrs:{"name":"fade"}},[(_vm.Render)?_c('img',{staticClass:"loader__item",attrs:{"src":require("@/assets/Images/Global/Loader.gif"),"alt":""}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }